// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__36MRp","head":"Table_head__lkqK7","col":"Table_col__3GOTj"};